import { signOut as amplifySignOut } from 'aws-amplify/auth';

export const signOut = () => {
  return amplifySignOut();
};
